import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const natalShopping: ThemeOptions = {
  palette: {
    primary: {
      main: '#00425a',
    },
    secondary: {
      main: '#c6a031',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#00256e',
    },
  },
};
